import StyleFontUtil from "./styleFontUtil";
import StyleTypesUtil from "./types/styleTypesUtil";

// TODO: move these to es.api.style or move methods in es.api.style here

export default class StyleUtil {
    readonly font = new StyleFontUtil();
    readonly types = new StyleTypesUtil();

    /**
     * Get font name from a google font style
     * e.g. "'Playfair+Display:400,400italic,700,700italic:latin', serif" returns "Playfair Display"
     * 
     * @param title 
     * 
     * @returns 
     */
    getFontName(title: string): string {
        if (!title) {
            return "";
        }

        if (title.indexOf(",") > -1) {
            title = title.split(",")[0];
        }

        if (title.indexOf("'") > -1) {
            title = title.split("'")[1];
        }

        if (title.indexOf('"') > -1) {
            title = title.split('"')[1];
        }

        if (title.indexOf(":") > -1) {
            title = title.split(":")[0];
        }

        title = title.replaceAll("+", " ");
        //es.log.info("getFontName", title);

        return title;
    }
}
